import { notification } from 'antd';
import './notification.scss';
import { cn } from '../../../utils/string/cn.utils';

export const openNotification = ({
  key,
  icon,
  iconColor,
  title,
  description,
  closable,
  className,
  classNames,
  duration,
  placement,
  ...props
}) => {
  notification.open({
    key: key,
    message: (
      <div className="flex px-12 py-8 items-center gap-12 self-stretch">
        <span
          className="w-24 h-24 flex"
          style={{ color: iconColor || '#F97D16' }}
        >
          {icon}
        </span>
        <span className="title-medium">{title}</span>
      </div>
    ),
    description: (
      <div className="mt-[-8px] flex pt-12 pb-12 ps-48 pe-12 items-start justify-center gap-12 self-stretch flex-col border-b-[1px]  border-t-[1px] border-[#E8E8E8]">
        <span className="text-body-medium">{description}</span>
      </div>
    ),
    closable: closable || false,
    duration: duration || null,
    placement: placement || 'topRight',
    className: className || '!p-0 gap-0',

    ...(props ?? {}),
  });
};

export const closeNotification = key => {
  notification.destroy(key);
};
